
import * as XLSX from 'sheetjs-style';
import { saveAs } from 'file-saver';

export const ExcelPillerWiseUploadData = (props) => {

    const {
        ExcelData,
        name,
        FinancialYear,
        Month,
        setUploadData
    } = props



    const exportStyledExcel = () => {
        const wsData = [
            [
                "Sr.No",
                "M_FinancialYearID",
                "M_MonthID",
                "M_WardID",
                // "Ward_Name",
                "M_ELEC_PillerID",
                "PillerNo",
                "PillerBenchMark",
                "Max",
                "Min",
                "Remark"
            ]
            // [
            //     FinancialYear,
            //     Month,
            //     "",
            //     "",
            //     "",
            //     "",
            //     "",
            //     "",
            //     "",
            //     "",
            // ]
        ];

        // 🔥 Map API data to Excel rows
        ExcelData?.table?.forEach((item, index) => {
            wsData.push([
                index + 1,               // Sr.No
                FinancialYear,           // M_FinancialYearID
                Month,                   // M_MonthID
                item.m_WardID || "",     // M_WardID
                item.m_eleC_PillerID || "", // M_ELEC_PillerID
                item.pillerNo || "",     // PillerNo
                "",                      // PillerBenchMark
                "",                      // Max
                "",                      // Min
                ""                       // Remark
            ]);
        });

        const ws = XLSX.utils.aoa_to_sheet(wsData);
        const centerStyle = {
            alignment: { horizontal: "center", vertical: "center" }
        };

        // Column widths
        ws['!cols'] = [
            { wch: 10 },  // Sr
            { wch: 20 },  // Financial 
            { wch: 10 },  // Month
            { wch: 10 },  // M_WardID
            { wch: 25 },  // M_ELEC_PillerID
            { wch: 20 },  // PillerNo
            { wch: 20 },  // PillerBenchMark
            { wch: 10 },  // Max
            { wch: 10 },  // Min
            { wch: 30 },  // Remark


        ];

        const headerStyle = {
            font: {
                bold: true,
                color: { rgb: "FFFFFF" }
            },
            fill: {
                patternType: "solid",
                fgColor: { rgb: "333333" }
            },
            alignment: {
                horizontal: "center",
                vertical: "center"
            },
            border: {
                top: { style: "thin", color: { rgb: "FFFFFF" } },
                bottom: { style: "thin", color: { rgb: "FFFFFF" } },
                left: { style: "thin", color: { rgb: "FFFFFF" } },
                right: { style: "thin", color: { rgb: "FFFFFF" } }
            }
        };

        // Apply styles
        ws['A1'].s = headerStyle;
        ws['B1'].s = headerStyle
        ws['C1'].s = headerStyle
        ws['D1'].s = headerStyle
        ws['E1'].s = headerStyle
        ws['F1'].s = headerStyle
        ws['G1'].s = headerStyle
        ws['H1'].s = headerStyle
        ws['I1'].s = headerStyle
        ws['J1'].s = headerStyle
        // ws['K1'].s = headerStyle
        // ws['L1'].s = headerStyle
        // ws['M1'].s = headerStyle
        // ws['N1'].s = headerStyle

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([wbout], { type: "application/octet-stream" });
        saveAs(blob, "Piller Wise Bench Mark.xlsx");

    };

    const handleClick = () => {
        setUploadData(2)
        exportStyledExcel()
    }

    return <button
        // className="btn btn-primarys1 activebutton mx-3 px-5" 
        className="btn btn-primarys1 activebutton px-3"
        type="button"
        onClick={handleClick} >

        {"Download Excel"}

    </button>;
};

